

import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const getProductBrand = () => "isanroute";

const formatPrice = (price) => Number(price).toFixed(2);

const getCompareAtPrice = (price) => {
  const compareAt = Math.round(Number(price) * 1.43);
  return compareAt > Number(price) ? compareAt.toFixed(2) : null;
};

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === Number(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);

  useEffect(() => {
    setSelectedSize(product?.size?.[0] || "");
    setSelectedColor(product?.colors?.[0] || "");
    setSelectedImage(0);
  }, [product]);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  const galleryImages = product.images?.length ? product.images : [product.image];
  const compareAtPrice = getCompareAtPrice(product.price);
  const detailFeatures = (product.Features || []).slice(0, 2);

  return (
    <div className="product-detail">
      <div className="product-detail__layout">
        <div className="product-detail__gallery">
          <div className="product-detail__image-frame">
            <img
              src={galleryImages[selectedImage]}
              alt={product.name}
              className="product-detail__main-image"
            />
          </div>
          {galleryImages.length > 1 && (
            <div className="product-detail__dots">
              {galleryImages.map((image, index) => (
                <button
                  key={image}
                  type="button"
                  className={`product-detail__dot ${
                    selectedImage === index ? "is-active" : ""
                  }`}
                  onClick={() => setImage(index)}
                  aria-label={`Show image ${index + 1}`}
                />
              ))}
            </div>
          )}
        </div>

        <div className="product-detail__info">
          <span className="product-detail__brand">{getProductBrand(product)}</span>
          <h1 className="product-detail__title">{product.name}</h1>

          <div className="product-detail__pricing">
            <span className="product-detail__price">${formatPrice(product.price)}</span>
            {compareAtPrice && (
              <span className="product-detail__compare-price">
                ${compareAtPrice}
              </span>
            )}
          </div>

          <div className="product-detail__divider" />

          <div className="product-detail__copy">
            {product.description?.slice(0, 2).map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>

          {detailFeatures.length > 0 && (
            <ul className="product-detail__features">
              {detailFeatures.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
          )}

          <div className="product-detail__option">
            <span className="product-detail__option-label">Size:</span>
            <div className="product-detail__sizes">
              {product.size?.map((size) => (
                <button
                  key={size}
                  type="button"
                  className={`product-detail__size-button ${
                    selectedSize === size ? "is-selected" : ""
                  }`}
                  onClick={() => setSelectedSize(size)}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>

          <div className="product-detail__option">
            <span className="product-detail__option-label">Color:</span>
            <div className="product-detail__sizes">
              {product.colors?.map((size) => (
                <button
                  key={size}
                  type="button"
                  className={`product-detail__size-button ${
                    selectedColor === size ? "is-selected" : ""
                  }`}
                  onClick={() => setSelectedColor(size)}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>

          <button
            type="button"
            className="product-detail__add-to-cart"
            onClick={handleAddToCart}
          >
            ADD TO CART
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
